module.exports = __webpack_public_path__ + "img/pos-icon.a36de89a.svg";